import React from 'react';
import HeroSection from '../components/HeroSection';
import ValueProposition from '../components/ValueProposition';
import PopularProducts from '../components/PopularProducts';
import HowItWorks from '../components/HowItWorks';
import FeaturedSupermarkets from '../components/FeaturedSupermarkets';
import RecentPriceDrops from '../components/RecentPriceDrops';

export default function HomePage() {
  return (
    <div>
      <HeroSection />
      <ValueProposition />
      <PopularProducts />
      <HowItWorks />
      <FeaturedSupermarkets />
      <RecentPriceDrops />
    </div>
  );
} 